<template>
    <div>
        <div class="main-comment">
            <label class="control-label" for="comment">{{ trans('add_comment')}}</label>
            <textarea id="comment" v-model="comment" class="form-control col-sm-7 autoExpand" placeholder="Leave a note"></textarea>
            <div class="buttons section">
                <button @click="submitComment" class="btn btn-primary" type="submit"><i class="icon icon-edit"></i> {{ trans('comment')}}</button>
            </div>
        </div>

        <h3 class="form-heading">Comment History</h3>
        <div class="comment-history panel-row row">
            <div class="col-md-12">
                <div class="media">
                    <ul class="media commentList media-list">
                        <li v-for="comment in model.comments" :id="'commentListID-' + comment.public_id" class="media">
                            <div class="media-left">
                                <span class="initial initial-sm">{{ comment.first_name.charAt(0) + comment.last_name.charAt(0) }}</span>
                            </div>
                            <div class="media-body">
                                <div class="commenter">
                                    <span class="sub-text">
                                        <strong>{{ comment.first_name }} {{ comment.last_name }}</strong>
                                        commented
                                        <span v-if="comment.entity_title && comment.entity_title != ''">
                                            <strong> on {{ comment.entity_title }}</strong>
                                            <span v-if="comment.entity_title != comment.entity"> in <strong>{{ comment.entity }}</strong></span>
                                        </span>
                                        <div class="date">{{ comment.created_at }}</div>
                                    </span>
                                    <a class="btn-delete commentDeleteBtns pull-right" :id="'commentID-' + comment.public_id">
                                        <i class="icon icon-cancel" aria-hidden="true"></i>
                                    </a>
                                </div>
                                <div class="comment-outer">
                                    <div class="comment-inner">
                                        <p style="word-wrap: break-word;">{{ comment.comment }}</p>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <strong v-if="model.comments.length == 0">There be no comments.</strong>
                </div> <!-- .media -->
            </div> <!-- .col-md-10 -->
        </div> <!-- .comments -->
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                comment: '',
                model: {
                    user: {},
                    public_id:0,
                    tags: [],
                    comments: []
                }
            }
        },
        components: {
            'comment-list': require('../components/comment-list.vue').default
        },
        created() {
            this.$eventHub.$on('setComments', this.setComments);
        },
        methods: {
            submitComment() {
                this.axios.post('/api/comment', {
                    id: this.model.public_id,
                    entity: 'company',
                    comment: this.comment
                }).then(function (response) {
                });

                let comment = {
                    first_name: this.model.user.first_name,
                    last_name: this.model.user.last_name,
                    initials: this.model.user.initials,
                    created_at: 'now',
                    comment: this.comment
                };
                this.model.comments.unshift(comment);
                this.comment = '';
            },
            setComments(data) {
                let vm = this;
                $.each(this.model, function (key, value) {
                    let val = '';
                    if (typeof data[key] !== 'undefined') {
                        val = data[key];
                    }
                    vm.model[key] = val;
                });
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('setComments', this.setComments)
        }
    }
</script>
